/* eslint-disable prefer-template */
import React from "react";
import { Link, useLocation } from "react-router-dom";

import {
  ListItemTextNav,
  NavItem,
  style,
  Container,
  Row,
  BoxIcon,
  TagNovo,
} from "./styles";

interface Props {
  icon?: JSX.Element;
  name?: string;
  route?: string;
  onPress?: Function;
  isArrow?: boolean;
  tagNovo?: boolean;
  arrow?: JSX.Element;
  isExpanded?: boolean;
}

const ItemListSideMenu: React.FC<Props> = ({
  icon,
  name,
  onPress,
  route,
  isArrow,
  arrow,
  tagNovo,
  isExpanded = true,
}) => {
  const location = useLocation();
  const isActive = Boolean(
    route &&
      (location.pathname === route ||
        (route !== "/menu" && location.pathname.startsWith(route + "/")) ||
        (route === "/menu" && location.pathname === "/menu"))
  );

  const handleNavigation = () => {
    if (route) {
      return (
        <>
          <Container isExpanded={isExpanded} isActive={isActive}>
            {/* @ts-ignore */}
            <Link to={route || null} style={style}>
              <NavItem
                isExpanded={isExpanded}
                isActive={isActive}
                onClick={() => (onPress ? onPress() : null)}
              >
                <BoxIcon isExpanded={isExpanded} isActive={isActive}>
                  {icon}
                </BoxIcon>
                <ListItemTextNav isExpanded={isExpanded} isActive={isActive}>
                  {name}
                </ListItemTextNav>
                {tagNovo && isExpanded ? (
                  <>
                    <TagNovo>
                      <p>NOVO</p>
                    </TagNovo>
                  </>
                ) : (
                  <></>
                )}
                {isArrow && arrow}
              </NavItem>
            </Link>
          </Container>
        </>
      );
    }
    return (
      <Container isExpanded={isExpanded} isActive={false}>
        <NavItem
          isExpanded={isExpanded}
          isActive={false}
          defaultValue={isArrow ? 0 : 1}
          onClick={() => (onPress ? onPress() : null)}
        >
          <Row>
            <BoxIcon isExpanded={isExpanded} isActive={false}>
              {icon}
            </BoxIcon>
            <ListItemTextNav isExpanded={isExpanded} isActive={false}>
              {name}
            </ListItemTextNav>
          </Row>
          {isArrow && arrow}
        </NavItem>
      </Container>
    );
  };
  return <>{handleNavigation()}</>;
};
export default ItemListSideMenu;
